/**
 * Created by phatbass on 1/1/16.
 */

angular.module('dekky.forms.http', [])
    .service('http', function ($window) {
        this.authenticationListener = function (response) {
            if (angular.isDefined(response.status) ) {
                if (response.status == 401) {
                    $window.location.href = Routing.generate('fos_user_security_login');
                }
            }

            return response;
        }
    });
